import axiosInstance from "../axiosInstance";

export const addTempMarkApi = data => {
  return axiosInstance.post(`/api/map/temp-mark`, data);
};

export const showTempMarkApi = (id, cancelToken) => {
  return axiosInstance.get(`/api/map/temp-mark/${id}`, {
    cancelToken,
  });
};

export const updateTempMarkApi = (id, data) => {
  data.append('_method', 'PUT')
  return axiosInstance.post(`/api/map/temp-mark/${id}`, data);
};

export const addMarkApi = data => {
  return axiosInstance.post(`/api/map/marks`, data);
};

export const editMarkApi = (id, data) => {
  return axiosInstance.post(`/api/map/mark-item-update/${id}`, data);
};

export const RemoveTempMarkApi = (temp_mark_id) => {
  return axiosInstance.delete(`/api/map/temp-mark/${temp_mark_id}`);
};

export const showMarkApi = mark_id => {
  return axiosInstance.get(`/api/map/mark-item/${mark_id}`);
};

export const getAllMarksForMapApi = (map_id, tag_ids) => {
  return axiosInstance.get(`/api/map/all-marks/${map_id}?tag_ids=${tag_ids}`);
};

export const getMarkPreviewApi = marks_id => {
  return axiosInstance.get(`/api/maps/mark-preview/${marks_id}`);
};

export const showMarksApi = marks_id => {
  return axiosInstance.get(`/api/map/marks/${marks_id}`);
};
